// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SM-z","modalContent":"TM-z","header":"UM-z","close":"VM-z"};